import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, Subject, timer } from 'rxjs';
import { map, shareReplay, takeUntil, switchMap } from 'rxjs/operators';
import {AppSettings} from '../common/app.settings';
import {BaseService} from './base.service'
@Injectable()
export class DashboardService extends BaseService{
    private cache$: Observable<any>;
    private reload$ = new Subject<void>();

    constructor(http: HttpClient) {
        super(http);        
    }
    get dashboard() {//Dashboard data will be refreshed every 10 minutes
      if (!this.cache$) {
        const timer$ = timer(0, AppSettings.CACHE_REFRESH_INTERVAL);
      this.cache$ = timer$.pipe(
        switchMap(() => this.getDashboardData()),
        takeUntil(this.reload$),
        shareReplay(1)
      );
        }
     return this.cache$;
      }
    getDashboardData() {
            // get dashboard data from api
            return this.http.get(`${AppSettings.API_ENDPOINT}${AppSettings.VV_DASHBOARD_ALL_EP}`)
                .pipe(map((response: Response) => response));
    }
    getCustomUsageReport(model:any) {
      //var params = JSON.stringify(model);
      // get dashboard data from api
      var url = AppSettings.VV_STATUS_WITH_DATE_RANGE_EP;
      if(model.starttime && model.endtime){
        var start = new Date(model.starttime).getTime();
        var end = new Date(model.endtime).getTime();
        url = url+'?type='+model.type + '&starttime='+start+'&endtime='+end;
      }
      if(model.tenant && model.tenant!='' && model.tenant!=undefined && model.tenant!='All')
      {  
        if (url == AppSettings.VV_STATUS_WITH_DATE_RANGE_EP)
          url = url+'?tenant='+model.tenant;
        else 
          url = url+'&tenant='+model.tenant;
        if(model.environment && model.environment!='' && model.environment!=undefined)
          url = url+'&env='+model.environment;
    }
      return this.http.get(`${AppSettings.API_ENDPOINT}${url}`)
          .pipe(map((response: Response) => response));
}
    clearCache() {
        // Calling next will complete the current cache instance
        this.reload$.next();    
        this.cache$ = null;
      }
    
}